export const INITIAL_FILTERS = {
  user_id: "",
  name: "",
  email: "",
  contactNo: "",
  date_from: "",
  date_to: "",
  subscription: "",
  source: "",
  currency: "",
};

export const LIMIT = 15;

export const SOURCE_LABELS = {
  manual: "Manual",
  revenuecat: "RevenueCat",
};
